import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserApiService } from '../commons/services/api/user/user-api.service';
import { SessionStorageService } from '../commons/services/local/storage/storage.service';
import { AuthService } from '../commons/services/local/auth-services';
import { DataUserService } from '../commons/services/local/data-user.service';
import { customBlankSpacesValidator } from '../validations/form-validations';
import { IResponse } from '../commons/services/api/api-models-base.interface';
import { IResponseLogin } from '../commons/services/api/user/user-api.model.interface';
import { IDataPrivilege, IDataUser } from '../commons/models/data-user';
import { KEYS_WEB_STORAGE } from '../commons/util/emun';
import { PATH_HOME_PAGES, PATHS_CHANGE_PASSWORD_PAGES } from '../commons/config/path-pages';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  formGroup!: FormGroup;
  public isInvalidUserName = false;
  public isInvalidPassword = false;
  disableButton = false;
  public errorMessage: string;
  style = 'material';
  
  constructor(private _formBuilder: FormBuilder,
    private _userApiService: UserApiService,
    private _router: Router,
    private _sessionsStorageService: SessionStorageService,
    private _authService: AuthService,
    private _dataUserService: DataUserService) {
    this._loadFormGroup();
  }

  showPassword: boolean = false;

  togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
  }

  private _loadFormGroup(): void {
    this.formGroup = this._formBuilder.group(
      {
        userName: [null, [customBlankSpacesValidator, Validators.required]],
        password: [null, [customBlankSpacesValidator, Validators.required]]
      }
    );
  }

  ngOnInit(): void {
    history.pushState(null, '', location.href);
    window.onpopstate = () => {
      history.pushState(null, '', location.href);
    };
  }

  private _saveDatauser(response: IResponse<IResponseLogin>): void {
    const listPrivilege: IDataPrivilege[] = response.result.privilegios.map(privilegio => ({
      option: privilegio.opcion,
      state: privilegio.estado
    }));

    const dataUser: IDataUser = {
      id: response.result.id,
      fullName: response.result.nombreCompleto,
      changePassword: response.result.cambioDeClave,
      privileges: listPrivilege,
    };
    this._sessionsStorageService.setItem(KEYS_WEB_STORAGE.DATA_USER, dataUser);
  }

  clickLogin(): void {
    if (this.formGroup.valid) {
      this.disableButton = true;
      const userName = this.userField.value;
      const password = this.passwordField.value

      this._userApiService.login({ nombreDeUsuario: userName, clave: password }).subscribe({
        next: (response) => {
          this._saveDatauser(response);
          this._authService.login();
          if (this._dataUserService.getPasswordChangeStatus() == false) {
            this._router.navigateByUrl(PATH_HOME_PAGES.homePage.withSlash);
          }
          else {
            this._router.navigateByUrl(PATHS_CHANGE_PASSWORD_PAGES.changePasswordPage.withSlash);
          }
        },
        error: (error) => {
          this.disableButton = false;
          this.errorMessage = error.error.errorList[0].message;

        }
      })
    } else {

      if (this.userField.value == null) {
        this.isInvalidUserName = true;
      } else {
        this.isInvalidUserName = false;
      }
      if (this.passwordField.value == null) {
        this.isInvalidPassword = true;
      }
      else {
        this.isInvalidPassword = false;
      }
    }
  }

  onUserNameInput() {
    if (this.userField?.value) {
      this.isInvalidUserName = false;
    }
  }

  onPasswordInput() {
    if (this.passwordField?.value) {
      this.isInvalidPassword = false;
    }
  }

  get userField(): AbstractControl {
    return this.formGroup.get('userName')!;
  }

  get passwordField(): AbstractControl {
    return this.formGroup.get('password')!;
  }

}